
import CategoryList from "@modules/categories/categories";
import { ICategoryInput } from "@types";

interface Props {
  data: ICategoryInput[]
}

const Categories: React.FC<Props> = ({ data }) => {
  return (
    <div className="w-full  max-w-[1240px] m-auto">
      <div className=" mt-10">
        <CategoryList data={data || []} />
      </div>
    </div>
  );
};

export default Categories;
